import {
  AkaCriticalIllnessInsuranceType,
  CriticalIllnessInsuranceType,
  DeathInsuranceType,
  DisabilityInsuranceType,
} from "./Advice/adviceTypes";

import { HuseierneHouseContentsInsuranceType } from "Features/CheckPrice/Products/RiskProducts/HouseProducts/HuseierneHouseContents";
import { ChildInsuranceType } from "./LifeProducts/Child";
import { ChildHealthInsuranceType } from "./LifeProducts/Child/ProductPrice/ChildHealth/childHealthPriceInterfaces";
import { HealthInsuranceType } from "./LifeProducts/Health/healthTypes";
import { PregnantAndNewbornInsuranceType } from "./LifeProducts/PregnantAndNewborn/pregnantAndNewbornTypes";
import { AccidentInsuranceType } from "./RiskProducts/Accident/accidentTypes";
import { AkaFamilyAccidentInsuranceType } from "./RiskProducts/AkaFamilyAccident/akaFamilyTypes";
import { AkaTravelInsuranceType } from "./RiskProducts/AkaTravel";
import { AkaHouseContentsInsuranceType } from "./RiskProducts/HouseProducts/AkaHouseContents";
import { CabinInsuranceType } from "./RiskProducts/HouseProducts/Cabin/cabinTypes";
import { CabinContentsInsuranceType } from "./RiskProducts/HouseProducts/CabinContents";
import { HouseInsuranceType } from "./RiskProducts/HouseProducts/House/houseTypes";
import { HouseContentsInsuranceType } from "./RiskProducts/HouseProducts/HouseContents/houseContentsTypes";
import { TravelInsuranceType } from "./RiskProducts/Travel/travelTypes";
import { ValuablesInsuranceType } from "./RiskProducts/Valuables";
import { BoatInsuranceType } from "./RiskProducts/VehicleProducts/Boat/boatTypes";
import { CarInsuranceType } from "./RiskProducts/VehicleProducts/Car/carTypes";
import { CaravanInsuranceType } from "./RiskProducts/VehicleProducts/Caravan/constants";
import { ElectricScooterInsuranceType } from "./RiskProducts/VehicleProducts/ElectricScooter/interface";
import { MopedInsuranceType } from "./RiskProducts/VehicleProducts/Moped/mopedInterface";
import { MotorcycleInsuranceType } from "./RiskProducts/VehicleProducts/Motorcycle/motorcycleInterface";
import { TractorInsuranceType } from "./RiskProducts/VehicleProducts/Tractor/tractorInterface";
import { TrailerInsuranceType } from "./RiskProducts/VehicleProducts/Trailer/trailerInterface";
import { VeteranAutoInsuranceType } from "./RiskProducts/VehicleProducts/VeteranAuto/veteranAutoInterface";

export enum ProductBackendName {
  ACCIDENT = "accident",
  ADVICE = "advice",
  AKA_CHILD = "akachild",
  AKA_CRITICAL_ILLNESS = "akacriticalillness",
  AKA_FAMILY_ACCIDENT = "akafamilyaccident",
  AKA_GROUP_LIFE = "akagrouplife",
  AKA_HOUSE_CONTENTS = "akahousecontents",
  AKA_STUDENT = "akastudent",
  AKA_TRAVEL = "akatravel",
  AKA_HEALTH = "akahealth",
  ANIMAL = "animal",
  BOAT = "boat",
  CABIN = "cabin",
  CABIN_CONTENTS = "cabincontents",
  CAR = "car",
  CARAVAN = "caravan",
  CHILD = "newchild",
  CHILD_HEALTH = "childhealth",
  CRITICAL_ILLNESS = "criticalillness",
  DEATH = "death",
  DISABILITY = "disabilityflex",
  ELECTRIC_SCOOTER = "electricscooter",
  HEALTH = "health",
  HOUSE = "house",
  HOUSE_CONTENTS = "housecontents",
  HUSEIERNE_HOUSE_CONTENTS = "huseiernehousecontents",
  MOPED = "moped",
  MOTORCYCLE = "motorcycle",
  RENTAL = "rental",
  PREGNANT_AND_NEWBORN = "pregnantandnewborn",
  SOP_SICKNESS_LEAVE = "sopsicknessleave",
  TRACTOR = "tractor",
  TRAILER = "trailer",
  TRAVEL = "travel",
  VALUABLES = "valuables",
  VETERAN_AUTO = "veteranauto",
}

export type InsuranceType =
  | AccidentInsuranceType
  | AkaCriticalIllnessInsuranceType
  | AkaHouseContentsInsuranceType
  | AkaFamilyAccidentInsuranceType
  | AkaTravelInsuranceType
  | BoatInsuranceType
  | CabinContentsInsuranceType
  | CabinInsuranceType
  | CaravanInsuranceType
  | CarInsuranceType
  | ChildInsuranceType
  | ChildHealthInsuranceType
  | CriticalIllnessInsuranceType
  | DeathInsuranceType
  | DisabilityInsuranceType
  | ElectricScooterInsuranceType
  | HealthInsuranceType
  | HouseContentsInsuranceType
  | HouseInsuranceType
  | HuseierneHouseContentsInsuranceType
  | MopedInsuranceType
  | MotorcycleInsuranceType
  | PregnantAndNewbornInsuranceType
  | TractorInsuranceType
  | TrailerInsuranceType
  | TravelInsuranceType
  | ValuablesInsuranceType
  | VeteranAutoInsuranceType;

export const HUSEIERNE_SPECIFIC_PRODUCTS = [
  ProductBackendName.HUSEIERNE_HOUSE_CONTENTS,
  ProductBackendName.RENTAL,
];

export const AKADEMIKERNE_SPECIFIC_PRODUCTS = [
  ProductBackendName.AKA_CHILD,
  ProductBackendName.AKA_CRITICAL_ILLNESS,
  ProductBackendName.AKA_FAMILY_ACCIDENT,
  ProductBackendName.AKA_GROUP_LIFE,
  ProductBackendName.AKA_HEALTH,
  ProductBackendName.AKA_HOUSE_CONTENTS,
  ProductBackendName.AKA_STUDENT,
  ProductBackendName.AKA_TRAVEL,
];
